/**
 * Dégradé mono-teinte marque pour l'intensité (métrique couleur, PR-3 double
 * encodage MapWidget) : clair (valeur basse) → foncé (valeur haute).
 */

export const RAMP_FROM = '#E0E7FF'; // clair (valeur basse)
export const RAMP_TO = '#4F46E5'; // foncé (valeur haute)

function hexToRgb(hex: string): [number, number, number] {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
function toHex(n: number): string {
  return Math.round(n).toString(16).padStart(2, '0');
}

/** Couleur du dégradé RAMP_FROM→RAMP_TO pour un ratio [0,1] (clampé, NaN → 0). */
export function rampColor(ratio: number): string {
  const t = Number.isFinite(ratio) ? Math.min(1, Math.max(0, ratio)) : 0;
  const [r1, g1, b1] = hexToRgb(RAMP_FROM);
  const [r2, g2, b2] = hexToRgb(RAMP_TO);
  const r = r1 + (r2 - r1) * t;
  const g = g1 + (g2 - g1) * t;
  const b = b1 + (b2 - b1) * t;
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
